var map = {
	"./android.svg": "3dac",
	"./apple.svg": "1108",
	"./back-top.svg": "e240",
	"./close-X.svg": "ef82",
	"./close.svg": "7710",
	"./fxcnxh.svg": "a226",
	"./fxmrkc.svg": "6b62",
	"./fxrmkc.svg": "8a90",
	"./fxyxtc.svg": "3b8d",
	"./next.svg": "6e7d",
	"./play.svg": "fb4f",
	"./previous.svg": "252b",
	"./right-jiantou.svg": "f41d",
	"./right.svg": "9a71",
	"./search.svg": "8e8d",
	"./shares.svg": "fc4c",
	"./shenglvehao.svg": "1eae",
	"./xiaochengxu.svg": "6f1e",
	"./xihuan.svg": "1412"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";